(() => {
  if (window.sawStorefrontEventsReady) return;
  window.sawStorefrontEventsReady = true;
  const nfcPath = '/collections/nfc-bracelets-soulmatch-ai-wearable-support';
  const isHome = () => location.pathname === '/' && new URL(location.href).searchParams.get('view') !== 'lifestyle';
  const publish = (name, payload) => {
    if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    try { window.Shopify?.analytics?.publish?.(`saw:${name}`, payload); } catch {}
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    const section = link.closest('.shopify-section');
    const sectionId = section?.id || '';
    let name;
    if (url.hostname === 'www.soulmatch.store' || url.hostname === 'soulmatch.store') name = 'soulmatch_click';
    else if (url.origin === location.origin) {
      if (isHome() && url.pathname === nfcPath) name = 'home_nfc_cta_click';
      else if (isHome() && sectionId.endsWith('__product_list_cDW89r') && url.pathname.startsWith('/products/')) name = 'home_nfc_product_click';
      else if (sectionId.endsWith('__collection_list_ky6Jk4')) name = 'curated_space_click';
      else if (section?.querySelector('.saw-scenes') || url.searchParams.get('view') === 'lifestyle') name = 'lifestyle_section_click';
    }
    if (name) publish(name, { destination_path: url.pathname, section: sectionId.split('__').pop() || 'navigation', destination: url.searchParams.get('view') === 'lifestyle' ? 'lifestyle' : url.hostname });
    if (url.origin !== location.origin && !['www.soulmatch.store', 'soulmatch.store'].includes(url.hostname)) return;
    if (!['/', '/collections/', '/products/'].some(path => path === '/' ? url.pathname === '/' : url.pathname.startsWith(path)) && url.origin === location.origin) return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const current = new URL(location.href);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
      const value = current.searchParams.get(key);
      if (value && /^[a-zA-Z0-9_.~-]{1,80}$/.test(value) && !url.searchParams.has(key)) url.searchParams.set(key, value);
    }
    link.href = url.href;
  }, { capture: true });
})();
